/* ==========================================================
   DISPLAY ZONE - QUANTITY SELECTOR COMPANION UPDATER

   Purpose:
   Updates the companion content beside the quantity selector
   after a shopper changes product variants.

   Shopify's native quantity selector behavior remains handled
   by the theme. This script only refreshes the companion area.
   ========================================================== */

(() => {
  if (window.DZQuantitySelectorInitialized) return;

  window.DZQuantitySelectorInitialized = true;

  if (
    typeof subscribe !== 'function' ||
    typeof PUB_SUB_EVENTS === 'undefined'
  ) {
    return;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const sectionId = data?.sectionId;
    const html = data?.html;

    if (!sectionId || !html) return;

    const currentCompanion = document.getElementById(
      `DZ-Quantity-Companion-${sectionId}`
    );

    const updatedCompanion = html.getElementById(
      `DZ-Quantity-Companion-${sectionId}`
    );

    if (currentCompanion && updatedCompanion) {
      currentCompanion.replaceWith(
        updatedCompanion.cloneNode(true)
      );
    }
  });
})();